import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Subtitle = styled.h3.withConfig({
  displayName: "Subtitle",
  componentId: "sc-1ypspjg-0"
})(["display:block;font-weight:700;color:", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.colors.uiDD);
}, getFont(0, 'compact'), minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(0, 'compact')));